import { render, staticRenderFns } from "./CredorListAddNew.vue?vue&type=template&id=13180a01&"
import script from "./CredorListAddNew.vue?vue&type=script&lang=js&"
export * from "./CredorListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CredorListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports